import { BarChartUrl } from '@icons';
import { BarChartWidget } from '@features/components/ClinicalData/components';
import { ClinicalHeader } from '@features/components/ClinicalBarChart';
import { ClinicalData, OrganType } from '@/api/apis/case';
import { formatPFRatio } from './utils';

type PFRatioDataProps = {
  clinicalData: ClinicalData;
  color: string;
};

export const PFRatioData = ({ clinicalData, color }: PFRatioDataProps) => {
  const pfRatio = formatPFRatio(clinicalData);
  const firstValue = pfRatio?.[0]?.value;
  const last = pfRatio.at(-1);
  return (
    <BarChartWidget
      organType={OrganType.Lungs}
      color={color}
      header="PF Ratio"
      icon={BarChartUrl}
      values={pfRatio}
      baseLine={firstValue}
    >
      <ClinicalHeader
        currentValue={last?.value}
        prevValue={firstValue}
        diffLabel="from baseline"
        measurementUnits=""
        parameter="PF Ratio"
        ocsTime={last?.ocsTime}
        timeString={last?.time}
      />
    </BarChartWidget>
  );
};
